import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-profile-already-validated',
  templateUrl: './profile-already-validated.component.html',
  styleUrls: ['./profile-already-validated.component.scss'],
})
export class ProfileAlreadyValidatedComponent  implements OnInit {

  constructor(    private modalCtrl: ModalController,
    public translate: TranslateService,) { }

  ngOnInit() {}


  goBack(){
    this.modalCtrl.dismiss();
  }

}
